import http from "../services/http-common";
import JWT from '../services/Jwt';
import Crypto from "../services/Crypto";
import * as servidor from "../utils/Utils";
const VERSION = process.env.VUE_APP_VERSION_SISTEMA;

export default {
    async generar(datos, key) {
        const datosEncriptados = await Crypto.encriptar(datos, key);
        return http.post(`${servidor.getServidor()}/api/auth/token`, datosEncriptados);
    },

    caducar(datos) {
        return http.post(`${servidor.getServidor()}/api/auth/eliminar`, JWT.jwtEncodeJson(datos));
    },



    //Compartir link
    verificaAcceso(datos) {
        return http.post(`${servidor.getServidorPorAmbiente()}/api/auth/validar-compartir-link`, JWT.jwtEncodeJson(datos));
    },

    version() {
        return VERSION;
    },
};